import React from 'react';
import { Helmet } from 'react-helmet-async';
import { CheckCircle2 } from 'lucide-react';

const SoymilkPage = () => {
  const soymilk = {
    name: "Fresh Soymilk",
    description: "Creamy, nutritious soymilk made from premium non-GMO soybeans. A delicious plant-based alternative to dairy milk, perfect for drinking, cooking, or adding to your coffee.",
    volume: "500ml",
    protein: "4g per 100ml",
    features: [
      "Lactose-Free",
      "Non-GMO Soybeans",
      "Made Fresh Daily",
      "High Protein Content",
      "No Added Sugar",
      "Vegan & Plant-Based"
    ],
    nutritionalInfo: {
      calories: "54 kcal",
      protein: "4g",
      carbohydrates: "4.5g",
      fat: "1.8g",
      calcium: "120mg",
      "Vitamin B12": "Fortified"
    }
  };

  return (
    <>
      <Helmet>
        <title>Fresh Soymilk | Naru Tofu</title>
        <meta name="description" content="Fresh, preservative-free soymilk made from premium non-GMO soybeans. Rich in protein, calcium, and essential nutrients." />
        <link rel="canonical" href="https://narutofu.com/products/soymilk" />
      </Helmet>
      <section className="section-padding" style={{ minHeight: '100vh' }}>
      <div className="container">
        <div className="product-showcase">
          <div className="product-image-container">
            <img 
              src="https://customer-assets.emergentagent.com/job_transparent-tofu/artifacts/s6vxecng_soymilk%20bottle.png" 
              alt="Naru Tofu - Fresh Soymilk"
              className="product-image"
              style={{ width: '100%', borderRadius: '0px' }}
            />
          </div>
          
          <div className="product-details">
            <h1 className="hero-medium">{soymilk.name}</h1>
            <p className="body-large product-description">{soymilk.description}</p>
            
            <div className="product-specs">
              <div className="spec-item">
                <span className="body-small" style={{ color: 'var(--text-secondary)' }}>Volume</span>
                <span className="body-regular">{soymilk.volume}</span>
              </div>
              <div className="spec-item">
                <span className="body-small" style={{ color: 'var(--text-secondary)' }}>Protein</span>
                <span className="body-regular">{soymilk.protein}</span>
              </div>
            </div>
            
            <div className="product-features">
              {soymilk.features.map((feature, index) => (
                <div key={feature} className="feature-item">
                  <CheckCircle2 size={16} color="var(--text-primary)" />
                  <span className="body-regular">{feature}</span>
                </div>
              ))}
            </div>
            
            <div className="nutritional-info">
              <h4 className="heading-3" style={{ marginBottom: '16px' }}>Nutritional Information (per 100ml)</h4>
              <div className="nutrition-grid">
                {Object.entries(soymilk.nutritionalInfo).map(([key, value]) => (
                  <div key={key} className="nutrition-item">
                    <span className="body-small" style={{ color: 'var(--text-secondary)', textTransform: 'capitalize' }}>
                      {key}
                    </span>
                    <span className="body-regular">{value}</span>
                  </div>
                ))}
              </div>
            </div>
            
            <a 
              href="https://wa.me/919663840931?text=Hi%2C%20I%27d%20like%20to%20order%20Naru%20Tofu%20Fresh%20Soymilk" 
              target="_blank" 
              rel="noopener noreferrer"
              className="btn-primary"
              style={{ marginTop: '32px', width: '100%', textDecoration: 'none' }}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="#25D366" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: '8px' }}>
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
              </svg>
              Buy Now on WhatsApp
            </a>
          </div>
        </div>
      </div>
    </section>
    </>
  );
};

export default SoymilkPage;